export const VALIDATE = `${process.env.REACT_APP_API_URL}/bulk-uploader/validate`;
export const UPSERT = `${process.env.REACT_APP_API_URL}/bulk-uploader/upsert`;
